import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, Input, InputGroup} from 'reactstrap';
import { app } from '../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      brand_options: [],
      category_options: [],
      message: '',
      show: 'none'
    }
  }

  componentDidMount() {
    this.createCategoryOptions();
    this.createBrandOptions();
  }

  createBrandOptions() {
    app.database().ref('/brands').orderByChild('name').once('value', (snapshot)=>{
      let item, options = [];
      snapshot.forEach((child)=>{
        item = child.val();
        options.push(<option key={child.key} value={child.key+'##'+item.image}>{item.name}</option>);
      });
      
      this.setState({
        brand_options: options
      });
    });
  }

  createCategoryOptions() {
    app.database().ref('/categories').orderByChild('name').once('value', (snapshot)=>{
      let item, options = [];
      snapshot.forEach((child)=>{
        item = child.val();
        options.push(<option key={child.key} value={child.key+'##'+item.image}>{item.name}</option>);
      });
      this.setState({
        category_options: options
      });
    });
  }

  formSubmit(event) {
    event.preventDefault()

    const name = this.nameInput.value
    let category = this.categoryInput.value
    const category_name = this.categoryInput.options[this.categoryInput.selectedIndex].text
    const subCategory = this.subCatInput.value
    let brand = this.brandInput.value
    const brand_name = this.brandInput.options[this.brandInput.selectedIndex].text
    const file = this.fileInput.files[0]
    const fileVal = this.fileInput.value
    //console.log(name+"-"+category_name+"-"+fileVal)
    
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(fileVal)[1];

    if (name == '' || category == '' || brand == '' || fileVal == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    brand = brand.split('##');
    category = category.split('##');

    var ref = app.database().ref('products').push();
    this.setMessage('Uploading...');
    var uploadRef = app.storage().ref().child('images/products/'+ref.key+'.'+ ext);
    var uploadTask = uploadRef.put(file);
    uploadTask.on('state_changed', (storeSnap)=>{
      //console.log('processing')
    }, (error)=>{
      this.setMessage('Upload error');
    }, ()=>{
      //console.log(uploadTask.snapshot.downloadURL);
      ref.set({
        brand_id: brand[0],
        brand_image: brand[1],
        brand_name: brand_name,
        category_id: category[0],
        category_image: category[1],
        category_name: category_name,
        image: uploadTask.snapshot.downloadURL,
        name: name,
        status: 1,
        sub_category: subCategory
      })
      .then((dbSnap)=>{
        this.setMessage('Product saved');
        this.entryForm.reset()
      })
      .catch((error)=>{
        uploadRef.delete();
        this.setMessage(error.message);
      });
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.formSubmit(event) }} ref={(form) => { this.entryForm = form }}>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Product Name" innerRef={(input) => { this.nameInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="select" name="category" innerRef={(input) => { this.categoryInput = input }}>
                        <option value="">Select Category</option>
                        {this.state.category_options}
                      </Input>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Sub Category (optional)" innerRef={(input) => { this.subCatInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="select" name="brands" innerRef={(input) => { this.brandInput = input }}>
                        <option value="">Select Brand</option>
                        {this.state.brand_options}
                      </Input>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="file" name="file" innerRef={(input) => { this.fileInput = input }} />
                    </InputGroup>
                    <Button color="success" block>Submit</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/views/Products/Form.js